import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const ACCOUNTBLOCKCATEGORY = {
    orderBlock: [{ '01': '' }],
};

export const SETTIMEOUTVALUE = '2000';
export const CREDITCARDPAYMENTMESSAGE = () =>
    t('equity.common.constants.creditCardMsg');
export const EQUITYVALIDATEACCOUNT = {
    orderType: 'ZOR',
    sapPartnerId: '',
    soldtoId: '' ,
    district: '',
    territory: '',

};
export const CONTACTNUMBERVALIDATIONMESSAGE = () =>
    t('consignment.contactInfo.contactNumber.contactValidationMessage');

export const EQUITYORDERTYPE = 'ZOR';

export const BASESITEID = 'mdt_b2bsite_us';

export const EQUITY_PRODUCT_TEMPLATE_VALIDATION_POPUPMESSAGES = () => ({
    itemNotAvailable: (count) => {
        return {
            title: t('equity.common.constants.items'),
            heading1: `${count} ${t('equity.common.constants.itemsCart')}`,
            heading2: t('equity.common.constants.itemsCannot'),
            customerServiceMessage: '',
        };
    },
    tenItemTitle: t('equity.common.constants.items'),
    itemNotAllowedAsExtra: t(
        'ConsignmentAdd.common.bundleItems.constants.templateContainsItemsNotAllowed'
    ),
});

export const EQUITY_PRODUCT_VALIDATION_POPUPMESSAGES = () => ({
    itemNotAvailable: () => {
        return {
            title: t('equity.common.constants.items'),
            heading1: '',
            heading2: t('equity.common.constants.itemsEquity'),
            customerServiceMessage: t(
                'equity.common.constants.customerServices'
            ),
        };
    },
    tenItemTitle: t('equity.common.constants.items'),
    itemNotAllowedAsExtra: t(
        'ConsignmentAdd.common.bundleItems.constants.templateContainsItemsNotAllowed'
    ),
});

export const ITEMSDETAILS = [
    { salesOrg: { tissue: 'S030', nonTissue: 'S002' } },
    {
        priceType: {
            extPrice: 'extPrice',
            adjustedExtPrice: 'adjustedExtPrice',
        },
    },
    { materialType: { bundle: 'ZKMT' } },
];

export const SCREENNAMES = ['Account', 'Cart', 'Shipping', 'Details'];
export const RESPONSESUCCESS = '10001';
export const RESPONSEFAILURE = 'Server not available';
export const PRODUCTSNOTFOUNDCODE = '10201';

export const SORTORDER = {
    asc: 'ASC',
    desc: 'DESC',
};

export const UNKNOWNID = 'Unknown';
export const ALLDISTRICTS = 'ALL_Districts';
export const ALLTERRITORIES = 'All_Territories';
export const PRODUCTDETAILS = {
    itemProductKey: '',
    subItemProductKey: '',
};
